import React from 'react';
import { Box, Typography, BoxProps } from '@mui/material';

export interface FormFieldWrapperProps extends BoxProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  spacing?: number;
}

const FormFieldWrapper: React.FC<FormFieldWrapperProps> = ({
  title,
  description,
  children,
  required = false,
  error = false,
  helperText,
  spacing = 2,
  ...boxProps
}) => {
  return (
    <Box {...boxProps}>
      {title && (
        <Typography 
          variant="h6" 
          gutterBottom 
          sx={{ 
            mb: spacing,
            color: error ? 'error.main' : 'text.primary'
          }}
        >
          {title}
          {required && (
            <Typography 
              component="span" 
              color="error.main"
              sx={{ ml: 0.5 }}
            >
              *
            </Typography>
          )}
        </Typography>
      )}
      
      {description && (
        <Typography 
          variant="body2" 
          color="text.secondary" 
          sx={{ mb: spacing }}
        >
          {description}
        </Typography>
      )}
      
      {children}
      
      {helperText && (
        <Typography 
          variant="caption" 
          color={error ? 'error.main' : 'text.secondary'}
          sx={{ mt: 1, display: 'block' }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default FormFieldWrapper;
